import { IntegrationFieldConfigs } from '../integration-form-types/integration-field-config'

export class IntegrationFieldBuilder {
  config: IntegrationFieldConfigs = {
    placement: 0,
    isHidden: false,
  }

  placement(placement: number): this {
    this.config.placement = placement
    return this
  }

  isHidden(hidden: boolean): this {
    this.config.isHidden = hidden
    return this
  }
}
